import { render, staticRenderFns } from "./rea-loader.vue?vue&type=template&id=dee456ae&scoped=true"
import script from "./rea-loader.vue?vue&type=script&lang=js"
export * from "./rea-loader.vue?vue&type=script&lang=js"
import style0 from "./rea-loader.vue?vue&type=style&index=0&id=dee456ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee456ae",
  null
  
)

export default component.exports